var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_wrap"
  }, [_c('div', {
    staticClass: "media_sign"
  }, [_c('div', {
    staticClass: "btn_group"
  }, [_c('div', {
    on: {
      "click": _vm.toapply
    }
  }, [_c('span', [_vm._v("媒体证申请")]), _vm._v(" "), _c('span', [_vm._v("APPLY")])]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.toFind
    }
  }, [_c('span', [_vm._v("我的媒体证")]), _vm._v(" "), _c('span', [_vm._v("CERTIFICATE")])])])])])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20110f64","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mediaCenter/foreignMediaMain.vue
// module id = null
// module chunks = 